import React from 'react';

const HeroSection = () => {
    return (
        <section className="hero-section text-white" id='home'>
            <div className="container-fluid">
                <div className="row flex-column-reverse flex-md-row">
                    {/* Left Column (Image) */}
                    <div className="col-md-6">
                        <div className="hero-img">
                            <img
                                src="../images/Hero.png"
                                alt="Cloud Illustration"
                                className="hero-image"
                            />
                        </div>
                    </div>
                    {/* Right Column (Content) */}
                    <div className="col-md-6 d-flex flex-column justify-content-center p-0">
                        <div className="hero-content">
                            <h1>Bringing Order to Your Cloud</h1>
                            <h3>
                                Optimize, Secure, and visualize your
                                cloud environment with AI-powered insights
                            </h3>
                            <button className="btn btn-custom">Start Free Trial</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
